import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import { faClose, faBars } from '@fortawesome/free-solid-svg-icons';


const HamburgerMenu = ({navItems, className}) => {
    const [open, setOpen] = useState(false);

    return (
        <nav className={`${className} w-fit`}>
            {/* Desktop nav */}
            <ul className="md:flex relative items-center hidden md:visible list-none sm:gap-2 md:gap-8 xl:gap-16 justify-center text-xl transition">
                {navItems.map(({ label, to }) => (
                    <li key={to}>
                        <Link to={to} className=" text-gray-700 hover:text-black">{label}</Link>
                    </li>
                ))}
            </ul>

            {/* Mobile toggle button */}
            <div className="md:hidden">
                <button
                    onClick={() => setOpen(!open)}
                    className="p-2 text-gray-700 focus:outline-none absolute right-5 top-3"
                    aria-label="Toggle menu"
                >
                    {open ? <FontAwesomeIcon icon={faClose} className="h-8 w-8" /> : <FontAwesomeIcon icon={faBars} className="h-8 w-8" />}
                </button>
            </div>

            {/* Mobile nav dropdown */}
            {open && (
                <div className="md:hidden absolute w-full top-20 right-0 z-40 bg-white shadow-md py-4 px-6 rounded-b-lg">
                    <ul className="flex flex-col gap-4 list-none text-xl">
                        {navItems.map(({ label, to }) => (
                            <li key={to}>
                                <Link
                                    to={to}
                                    onClick={() => setOpen(false)}
                                    className="block text-gray-800 hover:text-primary transition"
                                >
                                    {label}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </nav>
    );
};

export default HamburgerMenu;
